import { ChangePasswordVisibility } from 'services/requests';
import { ChangePasswordFieldNames } from 'hooks/forms';

export const passwordVisibilityReducer = (
  state: ChangePasswordVisibility,
  action: string,
): ChangePasswordVisibility => {
  if (action === ChangePasswordFieldNames.currentPassword)
    return { ...state, currentPassword: !state.currentPassword };
  if (action === ChangePasswordFieldNames.newPassword)
    return { ...state, newPassword: !state.newPassword };
  if (action === ChangePasswordFieldNames.repeatNewPassword)
    return { ...state, repeatNewPassword: !state.repeatNewPassword };
  return state;
};

export const passwordVisibilityInitialData = {
  currentPassword: true,
  newPassword: true,
  repeatNewPassword: true,
};
